<div class="instruction-card">
  <div class="d-flex align-items-center justify-content-between">
    <div class="d-flex flex-column gap-2">
      <div class="fund-indicator-name-container">
        <div class="indicator" [style.background-color]="fundType?.colour"></div>
        <div class="fund-name">{{ fundType?.name }}</div>
      </div>
      <div class="fund-value">{{ balance | currency }}</div>
    </div>
    <div class="percentage">{{ percentage?.toFixed(2) }}%</div>
  </div>
</div>
